import React, { useState } from "react";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  const handleSubmit = () => {
    setIsVisible(false);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 shadow-lg">
      <div className="max-w-screen-xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="text-sm">
          <p className="mb-1">
            Les informations recueillies via ce formulaire sont exclusivement
            destinées à l'association dans le cadre de son organisation. Seuls
            les membres du bureau y ont accès.
          </p>
          <p className="text-gray-300 text-xs">
            Vos données personnelles sont traitées de manière confidentielle et
            sécurisée.
          </p>
        </div>
        <div className="flex gap-3">
          <button
            onClick={handleSubmit}
            className="bg-white text-gray-900 px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-100 transition-colors"
          >
            J'ai compris
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
